export default [
  {
    question: `What do I need to know?`,
    answer: `Staking via Unagii delegates to the Stakewithus validator to help secure the network and receive a share of incentivized rewards earned. Rewards are earned by staking tokens and are paid out on a per block basis. Users can withdraw at any time.`,
  },
  {
    question: `Where does the rewards come from?`,
    answer: `All rewards come from a mixture of stake subsidies plus gas fees. 1 billion SUI tokens are locked as stake subsidies to be distributed starting in epoch 20, with 1,111,111 SUI distributed in each of the initial 90 epochs. Subsequently, the subsidy amount will fall by 10% and remain constant for next 90 epochs. This pattern will repeat until all subsidies are distributed.`,
  },
  {
    question: `Is there a lock-up period?`,
    answer: `There is no unbonding period. However, stakers can only choose to unbond ALL of their staked SUI tokens and receive it together with accrued staking rewards up till the latest epoch.`,
  },
  {
    question: `What are the risks?`,
    answer: `Your SUI will be staked to StakeWith.Us, a Singapore government backed staking infrastructure provider. There are slashing risks on the staking rewards if the validator votes for a overly low gas price quote. Read about StakeWith.Us.`,
  },
  {
    question: `Where can I view governance proposals for Sui? How does voting work?`,
    answer: `Governance mechanisms are still in design - to be updated.`,
  },
  {
    question: `Is there a fee?`,
    answer: `Usual validation fees will be charged on the Stakewith.us validator.`,
  },
];
